import React from "react";

export default function PageChange(props) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
      height: '100vh'}}>
      <i className="fas fa-circle-notch animate-spin text-blueGray-700 mx-auto text-6xl"></i>
    </div>
  );
}
